import { api } from "@/lib/api";
import {
  CreateProvider,
  mapCreateProviderToDto,
  mapProviderFromDto,
  Provider,
  ProviderDtoSchema,
} from "@/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getProvidersQueryOptions } from "./get.hooks";

export function useCreateProvider(opts?: {
  onSuccess?: (provider: Provider) => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async (provider: CreateProvider) => {
      const dto = mapCreateProviderToDto(provider);
      const result = await api.post("/api/providers", dto, ProviderDtoSchema);
      return mapProviderFromDto(result);
    },
    onSuccess: (provider) => {
      queryClient.setQueryData(getProvidersQueryOptions.queryKey, (old) => [
        ...(old ?? []),
        provider,
      ]);
      toast({
        title: "toast.providerCreated",
        variant: "success",
      });
      opts?.onSuccess?.(provider);
    },
    onError: () => {
      toast({
        title: "toast.createProviderError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
